export default {
    panel: {
        alternative: 'There are no connections to innovation fields'
    },
    empty: {
        title: 'Looking for innovations?',
        info: 'Unfortunately there is nothing to see here yet.',
        action: 'Create an innovation field!',
        button: 'Create innovation field'
    }
}
